import { type FC, type ReactNode } from "react";

import { Skeleton } from "@snapchat/snap-design-system";

interface ChartSkeletonContainer {
    skeletonActive: boolean;
    height?: number;
    children?: ReactNode;
}

export const ChartSkeletonContainer: FC<ChartSkeletonContainer> = ({ skeletonActive, height, children }) => {
    if (skeletonActive) {
        return <Skeleton height={height ?? 244} />;
    }

    return <>{children}</>;
};
